export default "__VITE_PUBLIC_ASSET__91c358b9__"